import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Button,
  Container,
  InputAdornment,
  Pagination,
  PaginationItem,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import ConfirmationModel from "components/ConfirmationModel";
import FilterBar from "components/FilterBar";
import Loader from "components/Loader";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setHeaderDetails } from "store/actions/header";
import { cleanAllProgramData, getInitialProgram } from "store/actions/program";
import {
  changePagination,
  deleteSessionById,
  getSessions,
  searchSessions,
} from "store/actions/sessions";
import { programStatuses } from "utils/programs.utils";
import SessionListBody from "./SessionListBody";
import useSubscriptionGuard from "hooks/useSubscriptionGuard";
import SessionListHeader from "./SessionListHeader";

const SessionList = () => {
  const { canCreate } = useSubscriptionGuard();
  const dispatch = useDispatch();
  const sessions = useSelector((state) => state.sessions.sessions);
  const navigate = useNavigate();
  const isLoadingSessions = useSelector(
    (state) => state.sessions.isLoadingSessions
  );
  const currentPage = useSelector((state) => state.sessions.currentPage);
  const [current, setCurrent] = useState(null);
  const [showDeleteModel, setDeleteModel] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filters, setFilters] = useState([]);
  const start = (currentPage - 1) * 10;
  const end = start + 10;
  const currentPageItems = (sessions || []).slice(start, end).length;

  const toggleDeleteModel = (ele = "") => {
    setDeleteModel(!showDeleteModel);
    setCurrent(ele);
  };
  const { type } = useSelector((state) => state.user.userDetails);
  const isAdmin = type?.toUpperCase() === "ADMIN";
  const [tabValue, setTabValue] = useState(isAdmin ? 2 : 0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    dispatch(getSessions(newValue));
  };
  useEffect(() => {
    dispatch(getSessions(tabValue));
    const navDetail = {
      isBreadcrumns: false,
      title: "Séances",
    };

    dispatch(setHeaderDetails(navDetail));
  }, []);
  const getStatusFilterValues = (values) => {
    setFilters(values);
    dispatch(searchSessions(searchQuery, values));
  };
  return (
    <>
      <Container
        maxWidth="xxl"
        className="header-box"
        sx={{ padding: "0 !important", marginBottom: "20px" }}
      >
        <Stack
          direction={{ xs: "column", sm: "row" }}
          alignItems={{ xs: "stretch", sm: "center" }}
          justifyContent="space-between"
          gap={1}
          mt={2}
        >
          <Stack
            direction={{ xs: "column", sm: "row" }}
            alignItems={{ xs: "stretch", sm: "center" }}
            gap={1}
          >
            <TextField
              placeholder="Rechercher une séance"
              name="search sessions"
              size="small"
              sx={{
                width: { sm: "100%", md: "414px" },
                ".MuiInputBase-root": {
                  background: "#ffffff",
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                dispatch(searchSessions(e.target.value, filters));
              }}
            />
            <FilterBar
              filters={[
                { title: "Statut", list: programStatuses, onSelect: getStatusFilterValues },
              ]}
            />
          </Stack>
          <Tooltip title={!canCreate ? "Mettez à jour votre abonnement pour accéder à cette fonctionnalité" : ""}>
            <span>
              <Button
                size="small"
                color="primary"
                variant="contained"
                disabled={!canCreate}
                sx={{ width: { xs: "100%", sm: "auto" } }}
                onClick={() => {
                  dispatch(cleanAllProgramData());
                  dispatch(getInitialProgram());
                  navigate("/fitness/sessions/create");
                }}
              >
                Créer une séance
              </Button>
            </span>
          </Tooltip>
        </Stack>
      </Container>
      <Container maxWidth="xxl">
        {!isAdmin && (
          <Box
            sx={{
              display: "flex",
              gap: 1,
              overflowX: "auto",
              flexWrap: "nowrap",
              scrollbarWidth: "none",
              "&::-webkit-scrollbar": { display: "none" },
              WebkitOverflowScrolling: "touch",
              mb: 2,
            }}
          >
            {[
              { label: "Mes Séances", value: 0 },
              { label: "Mes Templates", value: 1 },
              { label: "Templates Evocoach", value: 2 },
            ].map((tab) => (
              <Box
                key={tab.value}
                onClick={() => handleTabChange(null, tab.value)}
                sx={{
                  flexShrink: 0,
                  px: 2,
                  py: 0.75,
                  borderRadius: "20px",
                  fontSize: "13px",
                  fontWeight: tabValue === tab.value ? 600 : 400,
                  color: tabValue === tab.value ? "#ffffff" : "#4F5668",
                  backgroundColor: tabValue === tab.value ? "#0001FC" : "#F0F2F5",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  userSelect: "none",
                  WebkitTapHighlightColor: "transparent",
                  transition: "all 0.15s ease",
                }}
              >
                {tab.label}
              </Box>
            ))}
          </Box>
        )}
        <Stack gap={1}>
          <Loader isLoading={isLoadingSessions} />
          {!isLoadingSessions && <SessionListHeader />}
          {(sessions || []).length === 0 && !isLoadingSessions && (
            <Box textAlign="center" py={6}>
              <Typography fontSize="20px" fontWeight="600" color="#4F5668">
                {isAdmin
                  ? "Aucun template de séance créé pour l'instant."
                  : tabValue === 1
                    ? "Vous n'avez pas encore de templates personnels. Créez-en un dès maintenant !"
                    : tabValue === 2
                      ? "Les templates Evocoach arrivent très bientôt — restez connecté !"
                      : "Aucune séance pour le moment. Lancez-vous et créez votre première séance !"}
              </Typography>
            </Box>
          )}

          {!isLoadingSessions &&
            (sessions || [])
              .slice(start, end)
              .map((session, index) => (
                <SessionListBody
                  key={index}
                  session={session}
                  toggleDeleteModel={toggleDeleteModel}
                  isTemplate={isAdmin || tabValue >= 1}
                  isEvocoachTemplate={isAdmin || tabValue === 2}
                />
              ))}
          {!isLoadingSessions && (sessions || []).length > 10 && (
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography color="#000000" fontSize="12px" fontWeight="500">
                Affichage de {start + 1} à {start + currentPageItems} sur{" "}
                {sessions.length} résultats
              </Typography>
              <Pagination
                page={currentPage}
                onChange={(page, value) => dispatch(changePagination(value))}
                count={Math.ceil(sessions.length / 10)}
                variant="outlined"
                shape="rounded"
                color="secondary"
                size="small"
                siblingCount={0}
                renderItem={(item) => (
                  <PaginationItem
                    slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                    {...item}
                  />
                )}
              />
            </Stack>
          )}
        </Stack>
        <ConfirmationModel
          isOpen={showDeleteModel}
          title="Supprimer la session"
          body={[
            "Vous êtes sur le point de supprimer",
            <strong key="name"> {current?.name}</strong>,
            ". Cela le supprimera définitivement de votre bibliothèque.",
          ]}
          handleClose={toggleDeleteModel}
          maxWidth="sm"
          onConfirm={() => {
            dispatch(deleteSessionById(current._id, toggleDeleteModel));
          }}
        />
      </Container>
    </>
  );
};

export default SessionList;
